// React Imports
import * as React from 'react';
import {useSelector} from "react-redux";

// Mui Imports
import Box from '@mui/material/Box';
import Divider from "@mui/material/Divider";

// App Imports


// main function
export default function ContractDescriptionPanel(props) {


    // *********************** BEGIN STORE ********************************

    const selectorDescription = useSelector((state) => state.contractSlc.value.description);

    // ********************** END STORE ********************************


    // ****************** BEGIN RETURN ****************************

    return (
<Box>
    <Box
        sx={{
            height: 200,
            pt: 3,
            px: 35,
            flexGrow: 1,
            textAlign: 'center',         // centers inline text
            display: 'flex',             // optional: center the child itself
            alignItems: 'center',
            justifyContent: 'center',
        }}
    >
        <h2>{selectorDescription}</h2>
    </Box>

            <Divider/>
            {/*<Box*/}
            {/*    sx={{*/}
            {/*        // width: 600,*/}
            {/*        height: 40,*/}
            {/*        paddingLeft: 3*/}
            {/*    }}/>*/}
</Box>
    )

    // ****************** END RETURN ****************************

}
